<template>
  <App>
    <datatable
        :filters="filters"
        :headers="headers"
        :items="alunosTable"
        :loading="form.processing"
        singleSearch
    >
      <template #filters>
        <div class="card-title">
          <div class="d-flex align-items-center position-relative">
                        <span class="position-absolute ms-6">
                            <i class="fas fa-search"></i>
                        </span>
            <input data-kt-customer-table-filter="search"
                   v-model="filters.search"
                   type="text"
                   class="form-control form-control-solid w-450px ps-15"
                   placeholder="Nome do aluno, cpf, email"
            />
          </div>
        </div>
        <div class="card-toolbar flex-row-fluid justify-content-end gap-5">

        </div>
      </template>

      <template v-slot:cell.genero="{row}">
        <span class="badge badge-info" v-if="row.genero === 'F'">Feminino</span>
        <span class="badge badge-dark" v-else-if="row.genero === 'M'">Masculino</span>
        <span class="badge badge-secondary" v-else>Outro</span>
      </template>

      <template v-slot:cell.actions="{row}">
        <Link :href="this.route('app.alunos.edit', row.id)"
              method="get"
              as="button"
              type="button"
              class="btn btn-sm btn-clean btn-icon btn-active-light-primary"
              data-bs-toggle="tooltip"
              data-bs-trigger="hover"
              data-bs-delay-show="5000"
              title="Editar o usuário"
              data-bs-original-title="Ver usuário">
          <i class="fs-2 bi bi-pencil-square"></i>
        </Link>
        <a href="#" @click="remove(row)" class="btn btn-sm btn-clean btn-icon btn-active-light-primary"
           title="Remover">
          <i class="fs-2 bi bi-trash"></i>
        </a>
      </template>
    </datatable>
  </App>
</template>
<script>
import App from "@layout/App";
import axios from "axios";
import {ref} from "vue";
import {Link, useForm} from "@inertiajs/inertia-vue3";
import Datatable from "@forms/Datatable";
import SubmitButton from "@forms/SubmitButton";
import Datepicker from "@forms/Datepicker";
import FormGroup from "@forms/FormGroup";
import {success, error} from "@settings/toastr";

export default {
  props: ['alunos'],

  components: {
    FormGroup,
    Datepicker,
    SubmitButton,
    App,
    Link,
    Datatable
  },

  data: _ => ({
    headers: [
      {text: 'Código', value: 'id'},
      {text: 'Nome', value: 'nome', searchable: true},
      {text: 'Gênero', value: 'genero'},
      {text: 'E-mail', value: 'email', searchable: true},
      {text: 'Camiseta', value: 'camiseta'},
      {text: 'Telefone', value: 'telefone'},
      {text: 'CPF', value: 'cpf', searchable: true},
      {text: 'Ações', value: 'actions'},
    ],
    filters: {
      search: ''
    }
  }),

  mounted() {
    this.init();
  },

  setup(props) {
    const alunosTable = ref(props.alunos);

    const form = useForm({
      aluno: null,
    });

    return {
      alunosTable, form
    }
  },

  methods: {
    init() {
      this.emitter.emit('title', 'Alunos');
      this.emitter.emit('breadcrumb', [
        {title: 'Dashboard', link: 'app.home'},
        {title: 'Alunos'},
      ]);

      this.emitter.emit('action', {
          show: false
        }
      );
    },

    clearFilters() {
      Object.keys(this.filters).forEach(k => this.filters[k] = '');
    },

    list() {
      axios.get(this.route('app.alunos.filter')).then(response => this.alunosTable = response.data)
    },

    remove(aluno) {
      this.form.usuario = aluno.id;
      if (aluno.inscricao_id && aluno.inscricao_alunos === 2) {
        this.emitter.emit('alert', {
          text: 'Não é possível remover este aluno pois o projeto ficaria com a quantidade inferior ao mínimo necessário. ' +
              '<p><strong>Adicione outro aluno ao projeto antes de prosseguir.</strong></p>',
          cancelButtonText: 'Fechar',
          showConfirmButton: false
        });

        return true
      }

      let text = 'Deseja remover o(a) aluno(a) ' + aluno.nome + '?<br>';
      if (aluno.inscricao_id) {
        text += 'Este aluno participa de um projeto, ao excluí-lo também o removerá do projeto, deseja continuar?'
      }

      this.emitter.emit('alert', {
        text: text,
        success: this.confirmDelete
      });
    },

    confirmDelete() {
      this.form.delete(this.route('app.alunos.delete', {id: this.form.usuario}), {
        onError: error,
        onSuccess: () => {
          success('Aluno excluído com sucesso!');
          this.clearFilters()
          this.list()
        }
      });
    },
  },
};
</script>
